// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-1J2Af","button":"jgp-LUmGI","spacing__no_supporters":"jgp-2AGoc"};